import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const routeLoc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Store-detail routes render their own combined header (logo + tabs),
  // so hide the base logo-only header there.
  if (routeLoc.pathname.startsWith("/store/")) return null;

  return (
    <header className={`ff-header ${scrolled ? "ff-header--scrolled" : ""}`}>
      <div className="ff-header__inner">
        <Link to="/" className="ff-header__brand" aria-label="Store Locator home">
          <Logo />
        </Link>
      </div>
    </header>
  );
}

export default Header;
